import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PureModal from "react-pure-modal";
import "../styles/LeagueFilter.css";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  successbutton: {
    width: "109px",
    height: "34px",
    color: "#fff",
    border: "none",
    marginRight: "5px",
    boxSizing: "border-box",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "16px",
    textAlign: "center",
    cursor: "pointer",
    borderRadius: "6px",
    backgroundColor: "rgb(78, 173, 38)",
    "&:hover": {
      background: "rgb(78, 173, 38, 0.6)",
    },
  },
  cancelbutton: {
    width: "109px",
    height: "34px",
    color: "#fff",
    border: "none",
    boxSizing: "border-box",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "16px",
    textAlign: "center",
    cursor: "pointer",
    borderRadius: "6px",
    backgroundColor: "rgb(237, 146, 151)",
    "&:hover": {
      background: "rgb(237, 146, 151, 0.6)",
    },
  },
}));

const ResultsLeagueFilter = ({
  openLeagueFilter,
  setOpenLeagueFilter,
  competitionNames,
  onFilterChange,
  hiddenCompetitions,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [league, setLeague] = useState([]);
  window.HTMLElement.prototype.scrollIntoView = function () {};

  const changeAll = (a) => {
    setLeague(league.map((l) => ({ ...l, active: a })));
  };

  const filterLeague = () => {
    setOpenLeagueFilter(false);
    const hidden = league.filter((l) => !l.active).map((l) => l.val);
    onFilterChange(hidden);
  };

  useEffect(() => {
    if (openLeagueFilter) {
      if (competitionNames && competitionNames.length > 0) {
        const leagues = competitionNames.map((name, index) => ({
          key: `comp-${index}`,
          val: name,
          active: !hiddenCompetitions || !hiddenCompetitions.includes(name),
        }));
        setLeague(leagues);
      }
    } else {
      setLeague([]);
    }
  }, [openLeagueFilter, competitionNames, hiddenCompetitions]);

  return (
    <PureModal
      header={
        <div className="header">
          <div><span className={`lang-${localStorage.getItem('language')}`}>{t("Select League")}</span></div>
          <div className="header-select">
            <span onClick={() => changeAll(true)} className="actionspan">
              <span className="checkbox-checked"></span>
              <span className={`lang-${localStorage.getItem('language')}`}>{t("Select All")}</span>
            </span>
            <span onClick={() => changeAll(false)} className="actionspan">
              <span className="checkbox-unchecked"></span>
              <span className={`lang-${localStorage.getItem('language')}`}>{t("Deselect All")}</span>
            </span>
          </div>
        </div>
      }
      footer={
        <div className="center">
          <button
            onClick={() => filterLeague()}
            className={classes.successbutton}
          >
            <span className={`lang-${localStorage.getItem('language')}`}>{t("Done")}</span>
          </button>
          <button
            onClick={() => setOpenLeagueFilter(false)}
            className={classes.cancelbutton}
          >
            <span className={`lang-${localStorage.getItem('language')}`}>{t("Cancel")}</span>
          </button>
        </div>
      }
      isOpen={openLeagueFilter}
      onClose={() => {
        setOpenLeagueFilter(false);
        return true;
      }}
    >
      <div className={classes.root}>
        <Grid container spacing={3}>
          {league.map((option, index) => (
            <React.Fragment key={index}>
              <Grid item xs={4}>
                <input
                  type="checkbox"
                  checked={!!option.active}
                  onChange={() => {
                    const newLeague = [...league];
                    newLeague[index] = { ...newLeague[index], active: !newLeague[index].active };
                    setLeague(newLeague);
                  }}
                  value={option.key}
                  id={option.key}
                />{" "}
                <label className="pointer" htmlFor={option.key}>
                  {option.val}
                </label>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </div>
    </PureModal>
  );
};

export default ResultsLeagueFilter;
